<template>
  <div>
    <vx-card>
      <heading size="h1" style-size="h4" class="mb-5">Work Experience Questions</heading>
      <vs-tabs class="overwrite-tabs">
        <vs-tab :label="!isSmallerScreen ? 'Questions' : 'Questions'">
          <div class="tab-text my-5">
            <p class="mb-2">
              Please tick either <u>True</u>, <u>False</u> or <u>Not Sure Yet</u> next to each
              statement.
            </p>
            <p class="mb-5">Ensure you check all items before you begin your work experience.</p>
            <form id="form" class="my-5" @submit.prevent="save">
              <div
                class="vx-row mb-5 questionrow"
                v-for="(question, index) in questions"
                :key="index"
              >
                <div class="vx-col w-full md:w-2/3">{{ index }}. {{ question.question }}</div>
                <div class="vx-col w-full md:w-1/3 md:text-right mt-2 md:mt-0">
                  <div class="btn-group flex justify-end">
                    <vs-button
                      size="small"
                      class="success"
                      @click="answerQuestion(index, 1)"
                      :class="{ active: data['answer' + index] == 1 }"
                      :aria-current="data['answer' + index] == 1 ? 'true' : null"
                      :color="data['answer' + index] == 1 ? 'success' : 'dark'"
                      type="flat"
                      >True
                    </vs-button>
                    <vs-button
                      size="small"
                      class="danger"
                      @click="answerQuestion(index, 2)"
                      :class="{ active: data['answer' + index] == 2 }"
                      :aria-current="data['answer' + index] == 2 ? 'true' : null"
                      :color="data['answer' + index] == 2 ? 'danger' : 'dark'"
                      type="flat"
                      >False
                    </vs-button>
                    <vs-button
                      size="small"
                      class="warning"
                      @click="answerQuestion(index, 3)"
                      :class="{ active: data['answer' + index] == 3 }"
                      :aria-current="data['answer' + index] == 3 ? 'true' : null"
                      :color="data['answer' + index] == 3 ? 'warning' : 'dark'"
                      type="flat"
                      >Not Sure Yet
                    </vs-button>
                  </div>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col w-full">
                  <vs-checkbox v-model="data.confirmed" name="confirmed"
                    >I have read all the information in this module
                  </vs-checkbox>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col w-full">
                  <button class="btn btn-primary btn-size-medium mr-3 mb-1">Submit</button>
                  <router-link
                    to="/student/workplace-preparation"
                    class="btn btn-secondary btn-size-medium mb-1"
                  >
                    Back
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </vs-tab>
        <vs-tab :label="!isSmallerScreen ? 'Check Answers' : 'Check Answers'">
          <div class="tab-text my-5">
            <div
              class="vx-row mb-5 questionrow"
              v-for="(question, index) in questions"
              :key="index"
            >
              <div class="vx-col w-full sm:w-2/3">{{ index }}. {{ question.question }}</div>
              <div class="vx-col w-full sm:w-1/3 mt-3 sm:mt-0 answer_wrapper flex flex-col">
                <button
                  type="button"
                  class="no-style"
                  :aria-label="`Why? Question ${index}`"
                  @click="showWhy(index)"
                >
                  <vs-chip color="primary">
                    <vs-avatar icon-pack="feather" icon="icon-help-circle" class="ml-2" />
                    <span aria-hidden="true">Why?</span>
                  </vs-chip>
                </button>
                <div class="answer" v-if="data['answer' + index] == 1">True</div>
                <div class="answer" v-else-if="data['answer' + index] == 2">False</div>
                <div class="answer" v-else-if="data['answer' + index] == 3">Not Sure Yet</div>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import { successToast, errorToast } from '@/utils/toast';
import store from '@/store/store';

export default {
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    data: {
      get: function () {
        return this.getModuleData();
      },
      set: function (d) {
        this.setModuleData(d);
      },
    },
    isConfirmed() {
      return this.$store.getters['authStudent/preworkWorkplacePreparationModules'][
        this.$route.params.id
      ];
    },
    prework() {
      return this.$store.getters['authStudent/prework'];
    },
  },
  data() {
    return {
      questions: {
        1: {
          question:
            'If the employer asks me to do an extra day of unpaid work experience, I should do it.',
          why: 'It is your right to work unpaid for the set hours and days of your work experience placement only. Employers are not to take advantage of you by expecting you to work for them unpaid beyond these agreed hours.',
        },
        2: {
          question:
            'If I see water spilled on the floor, I should ignore it and leave it for the person who did it to clean up.',
          why: 'Workplace Health and Safety is everyone’s responsibility. The person who spilled it may not have realised this. Someone could slip and hurt themselves when you could have prevented it.',
        },
        3: {
          question:
            'If I am asked to do something I don’t like, I should still do it with enthusiasm.',
          why: "It is the employer's right to expect you to do each task with a good attitude. You are representing their business/company. It is also a sign of maturity to accept that even the most exciting jobs have mundane and boring aspects.",
        },
        4: {
          question:
            'If something is explained to me that I don’t understand and I am embarrassed to ask questions, it’s OK to figure it out for myself.',
          why: 'Employers prefer you ask questions than guess or underperform. Asking questions shows the employer that you want to get things right or learn something properly. It also demonstrates that you have good that communication skills. You are not expected to know or understand everything, but no one wants you guessing. ',
        },
        5: {
          question:
            'If I stain my work clothes while eating breakfast, I should change my clothes even if it is a very small mark.',
          why: 'It is important to an employer because you are representing their business/company. A big part of personal presentation is wearing clean clothes.',
        },
        6: {
          question:
            'If I miss my bus to my work experience placement, I should call the employer to let them know, apologise, and offer to make up the time. I should also let my school know.',
          why: 'Communicating with your employer regarding unplanned changes shows that you respect them and value their time. Communication with your school is also important as, as for many reasons, they need to know where you are and of any changes to your situation.',
        },
        7: {
          question:
            'A client comes in that I happen to know and is talking to my supervisor. The client is crying. Because I know and care for this person, it is ok to call their mum when I get home and tell her.',
          why: 'Everything you hear and see at work is confidential (private) - unless it breaks the law. You must understand the importance of confidentiality and know that legal implications might arise if you break confidentiality.',
        },
        8: {
          question:
            'One of the employees is a real “know-it-all” and makes lots of mistakes. They ask me to do a task that I know could be done better in a different way. When I make a suggestion, this employee takes offence and tells me to just do it the way they told me. Since I want to make a good impression with the employer and be seen to add value, it is ok to mention it discreetly and respectfully to the employer/supervisor.',
          why: 'It is ok to talk to your employer/manager privately about any concerns you have. There is always more than one way to solve a problem. You need to approach things diplomatically. On the one hand, you don’t want to complain unjustifiably about a permanent employee or cause unnecessary friction in the workplace. This will demonstrate your initiative, enthusiasm for the job, and problem-solving skills. You might consider expressing to the boss that you have an idea for an improvement in how a task is completed. On the other hand, you don’t need to accept the behaviour of people who treat you with rudeness or disrespect. In such instances, it is perfectly acceptable to explain the situation honestly to your boss and seek guidance on how best to handle the situation.',
        },
        9: {
          question:
            'I forget to put my phone on silent, and it rings when I am talking to a customer. It is acceptable to politely excuse myself and take the call.',
          why: 'Customers and your work must always come first. You should never leave or take your focus off the job to answer your personal calls (or make them). Leave things like that for your break time.',
        },
        10: {
          question:
            'I accidentally break a piece of equipment. No one saw me do it, so it is best not to say anything.',
          why: 'You must always tell the employer if you have broken or damaged anything. There could be safety ramifications, financial loss if something needs replacing quickly, or if they figure it out, you may be seen as dishonest, untrustworthy, and immature. Accidents happen and it is better to be known as clumsy than dishonest and disrespectful.',
        },
        11: {
          question:
            'As my supervisor is explaining something to me, I catch myself daydreaming and realise I have missed what was said. It is best to apologise straight up for losing focus and wasting their time and ask them to repeat the information so that I am sure to do the task well.',
          why: 'It is best to be honest and do the job well. Even if the employer is frustrated, you will have done the right thing and will most likely respect your honesty. It is better to own up now than to muddle through and potentially make a costly mistake later.',
        },
        12: {
          question:
            'I thought my work experience placement would be fun, but I find that I don’t relate to or even like anyone I am working with. Although I am disappointed and somewhat bored, I should remember that this is just one week of my life. Learning about the job and getting a good reference is enough motivation to muster some enthusiasm and keep going.',
          why: 'You are doing work experience to gain skills, knowledge, and experience, not to make friends. Things are often not how we envisage them, and it is a good opportunity to learn flexibility and perseverance in achieving a goal. ',
        },
      },
    };
  },
  methods: {
    save() {
      const answers = Object.entries(this.data).slice(0, 12);
      const selected = answers.filter((answer) => answer[1] !== 0);

      if (selected.length === answers.length) {
        this.saveModule(this.data);
      } else {
        this.$toast.error('You must answer all the questions', errorToast());
      }
    },
    answerQuestion(qID, answer) {
      this.$set(this.data, 'answer' + qID, answer);
    },
    showWhy(qID) {
      const question = this.questions[qID];
      if (question) {
        this.$vs.dialog({
          color: 'primary',
          title: `Why?`,
          text: question.why,
        });
      }
    },
  },
  watch: {
    'prework.workplace_preparation_modules'() {
      const modules = this.prework.workplace_preparation_modules;
      if (modules && modules[7]) {
        this.data = modules[7];
      }
    },
  },
  mounted() {
    if (this.isConfirmed) this.data.confirmed = true;

    const modules = this.prework.workplace_preparation_modules;

    if (modules && modules[7]) {
      this.data = modules[7];
    } else {
      this.data = {
        answer1: 0,
        answer2: 0,
        answer3: 0,
        answer4: 0,
        answer5: 0,
        answer6: 0,
        answer7: 0,
        answer8: 0,
        answer9: 0,
        answer10: 0,
        answer11: 0,
        answer12: 0,
        confirmed: false,
      };
    }
  },
  inject: ['saveModule', 'getModuleData', 'setModuleData'],
};
</script>
<style scoped lang="scss">
.questionrow {
  background: #f6f6f6;
  padding: 20px 10px;
  margin: 0;
  display: flex;
  justify-content: space-between;
}

.v-select {
  background: #fff;
}

.answer {
  padding: 5px 0px 5px 10px;
  white-space: nowrap;
  text-align: right;
}

.answer_wrapper .con-vs-chip {
  cursor: pointer;
  float: right;
}

.con-vs-chip .text-chip {
  margin-left: 10px !important;
}

// Hover text must also meet 4.5:1 on the #f6f6f6 question row (WCAG SC 1.4.3, audit
// 18.1 - "the colour contrast requirement includes text on mouse hover"). The previous
// mint/orange hover colours were 1.5:1 and 2.4:1.
.vs-button.small {
  &.success:hover {
    color: #0f5a30; // 7.5:1
  }

  &.danger:hover {
    color: #b01213; // 6.3:1
  }

  &.warning:hover {
    color: #8a4200; // 6.6:1
  }
}
</style>
